import React from 'react'
import cx from 'classnames'
import { Button, Header, Icon, Stack, Text } from '@crossfit/ui'
import ToolTip from './Tooltip'

import { useNotification } from 'components/Notification'
import copyToClipboard from './copy-to-clipboard'
import style from './style.module.css'
import { useMediaQuery } from 'hooks/useMediaQuery'

function AffiliateId({
  affiliateId,
  tooltip,
  className,
}: {
  affiliateId: number
  className?: string
  tooltip?: {
    headlineText: string
    descriptionText: string
  }
}) {
  const showNotification = useNotification()

  const isMobile = useMediaQuery('(max-width: 900px)')

  function handleCopyToClipboard() {
    copyToClipboard(affiliateId.toString())
    showNotification(`${affiliateId} has successfully copied to clipboard`)
  }

  return (
    <div className={cx(style.wrapper, className)}>
      <div className={style.labelWrapper}>
        <label htmlFor='affiliate-id'>Affiliate ID:</label>
        {tooltip && (
          <ToolTip
            trigger={isMobile ? 'click' : 'mouseenter focus click'}
            placement={isMobile ? 'bottom' : 'top-end'}
            content={
              <Stack
                style={{ zIndex: 800 }}
                direction='vertical'
                className={style.tooltipContent}
              >
                <Header size='xsmall' as='h3'>
                  {tooltip.headlineText}
                </Header>
                <Text mb={isMobile ? 5 : 0}>{tooltip.descriptionText}</Text>
                {isMobile && (
                  <Button variant='tertiary' size='small' color='white'>
                    Dismiss
                  </Button>
                )}
              </Stack>
            }
          >
            <div aria-label='affiliate id info'>
              <Icon name='info' className={style.icon} />
            </div>
          </ToolTip>
        )}
      </div>
      <div className={style.inputWrapper}>
        <input disabled value={affiliateId} id='affiliate-id' />
        <button
          aria-label='Copy affiliate ID to clipboard'
          onClick={handleCopyToClipboard}
        >
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M12.5 14V15C12.5 15.5523 12.0523 16 11.5 16H1.5C0.947715 16 0.5 15.5523 0.5 15V3C0.5 2.44772 0.947715 2 1.5 2H3.5V1C3.5 0.447716 3.94772 0 4.5 0H14.5C15.0523 0 15.5 0.447715 15.5 1V13C15.5 13.5523 15.0523 14 14.5 14H12.5ZM4.9 1.4V2H11.5C12.0523 2 12.5 2.44772 12.5 3V12.6H14.1V1.4H4.9ZM1.9 14.6V3.4H11.1V14.6H1.9Z'
              fill='currentColor'
            />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default AffiliateId
